/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../../components/GrayPanel';
import s from './updateEmuia.css';
import { fetchPrefixes } from '../../../actions/app';
import Select from 'react-select';
import fetch from '../../../core/fetch';

import {
  Col,
  Row,
  FormControl,
  FormGroup,
  ControlLabel,
  Form,
  Grid,
  Checkbox,
  Button,
} from 'react-bootstrap';

class FtpAccountDetails extends React.Component {
  static propTypes = {
    user: PropTypes.string.isRequired,
    passwd: PropTypes.string.isRequired,
    host: PropTypes.string.isRequired,
    prefix: PropTypes.string.isRequired,
    testStatus: PropTypes.bool,
  };

  render() {
    return (
      <Row>
        <h5 style={{ margin: '20px' }}>Konfiguracja kontaf FTP: </h5>
        <FormGroup validationState={this.props.user ? null : 'error'}>
          <Col componentClass={ControlLabel} xs={3} style={{ paddingTop: '5px' }}>
            Nazwa Użytkownika
          </Col>
          <Col xs={9}>
            <FormControl
              type="text"
              value={this.props.user ? this.props.user : ''}
              onChange={e => this.props.changeFtpAccount(e, 'user')}
            />
            <FormControl.Feedback style={{ right: '10px' }} />
          </Col>
        </FormGroup>

        <FormGroup validationState={this.props.passwd ? null : 'error'}>
          <Col componentClass={ControlLabel} xs={3} style={{ paddingTop: '5px' }}>
            Hasło
          </Col>
          <Col xs={9}>
            <FormControl
              type="text"
              value={this.props.passwd ? this.props.passwd : ''}
              onChange={e => this.props.changeFtpAccount(e, 'passwd')}
            />
            <FormControl.Feedback style={{ right: '10px' }} />
          </Col>
        </FormGroup>

        <FormGroup validationState={this.props.host ? null : 'error'}>
          <Col componentClass={ControlLabel} xs={3} style={{ paddingTop: '5px' }}>
            Host
          </Col>
          <Col xs={9}>
            <FormControl
              type="text"
              value={this.props.host ? this.props.host : ''}
              onChange={e => this.props.changeFtpAccount(e, 'host')}
            />
            <FormControl.Feedback style={{ right: '10px' }} />
          </Col>
        </FormGroup>

        <FormGroup validationState={this.props.prefix ? null : 'error'}>
          <Col componentClass={ControlLabel} xs={3} style={{ paddingTop: '5px' }}>
            Prefix
          </Col>
          <Col xs={9}>
            <FormControl
              type="text"
              disabled
              value={this.props.prefix ? this.props.prefix : ''}
              onChange={e => this.props.changeFtpAccount(e, 'prefix')}
            />
            <FormControl.Feedback style={{ right: '10px' }} />
          </Col>
        </FormGroup>
        <Col xs={9}>
          {this.props.testStatus === true ? <div>Pomyślnie utworzono połączenie FTP</div> : null}
          {this.props.testStatus === false ? <div>Nie udało się połączyć z FTP</div> : null}
        </Col>
        <Col xs={3}>
          <Button
            style={{ margin: '15px' }}
            className="pull-right"
            bsStyle="primary"
            onClick={this.props.testFTP}
          >
            Test
          </Button>
          <Button style={{ margin: '15px' }} className="pull-right" bsStyle="danger">
            Zapisz
          </Button>
        </Col>
      </Row>
    );
  }
}

class EmuiaUpdateDetails extends React.Component {
  runUpdate = () => {
    const ulr = `${process.env.API_URL}/emuia/${this.props.ftp_account.prefix}`;
    
  };

  render() {
    return (
      <Row>
        <FtpAccountDetails
          {...this.props.ftp_account}
          testFTP={this.props.testFTP}
          testStatus={this.props.testStatus}
          changeFtpAccount={this.props.changeFtpAccount}
        />
        <Row>
          <h5 style={{ margin: '20px' }}>Konfiguracja aktualizacji: </h5>

          <FormGroup>
            <Checkbox value={false}>Czy uruchommić w testowym środowisku</Checkbox>
          </FormGroup>
        </Row>

        <Row>
          <Button className="pull-right" bsStyle="warning">
            Uruchom aktualizację
          </Button>
        </Row>
      </Row>
    );
  }
}

class UpdateEmuia extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    arePrefixesFetched: PropTypes.bool.isRequired,
    fetchPrefixes: PropTypes.func.isRequired,
    prefixes: PropTypes.arrayOf(PropTypes.string),
  };

  state = {
    selectedOption: null,
    showOptions: false,
    ftp_account: null,
    testStatus: false,
  };

  testFTP = () => {
    fetch(`${process.env.API_URL}/ftp_accounts/test`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user: btoa(this.state.ftp_account.user),
        passwd: btoa(this.state.ftp_account.passwd),
        host: this.state.ftp_account.host,
        prefix: this.state.ftp_account.prefix,
      }),
    }).then(resp => {
      if (resp.status === 200) {
        this.setState({ testStatus: true });
      } else {
        this.setState({ testStatus: false });
      }
    });
  };

  handleChange = selectedOption =>
    this.setState({ selectedOption: { ...selectedOption } }, () => {
      if (this.state.selectedOption && this.state.selectedOption.value) {
        fetch(`${process.env.API_URL}/ftp_accounts/${this.state.selectedOption.value}`)
          .then(resp => {
            if (resp.status === 200) {
              return resp.json();
            }
            throw 'Błąd';
          })
          .then(r => {
            if (r) {
              this.setState({
                ftp_account: {
                  user: atob(r.account.user),
                  passwd: atob(r.account.passwd),
                  host: r.account.host,
                  prefix: r.account.prefix,
                },
                showOptions: true,
              });
            }
          })
          .catch(() =>
            this.setState({
              ftp_account: {
                user: null,
                passwd: '',
                host: 'mapa.inspire-hub.pl',
                prefix: this.state.selectedOption.value,
              },
              showOptions: true,
            }),
          );
      } else {
        this.setState({ showOptions: false, ftp_account: null });
      }
    });

  changeFtpAccount = (e, field) =>
    this.setState({
      ftp_account: {
        ...this.state.ftp_account,
        [field]: e.target.value,
      },
      testStatus: null,
    });

  render() {
    if (!this.props.arePrefixesFetched) this.props.fetchPrefixes();

    const optionValue = this.state.selectedOption && this.state.selectedOption.value;

    return this.props.arePrefixesFetched ? (
      <GrayPanel title="Aktualizacja emuiia">
        <Select
          name="form-field-name"
          value={optionValue}
          onChange={this.handleChange}
          options={
            this.props.prefixes ? this.props.prefixes.map(v => ({ value: v, label: v })) : []
          }
        />
        {this.state.showOptions ? (
          <EmuiaUpdateDetails
            testFTP={this.testFTP}
            testStatus={this.state.testStatus}
            ftp_account={this.state.ftp_account}
            changeFtpAccount={this.changeFtpAccount}
          />
        ) : null}
      </GrayPanel>
    ) : null;
  }
}

const mapState = state => ({
  prefixes: state.app.prefixes,
  arePrefixesFetched: state.app.arePrefixesFetched,
});
const mapDispatch = {
  fetchPrefixes,
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(UpdateEmuia),
);



// WEBPACK FOOTER //
// src/routes/admin/update_emuia/updateEmuia.js